/** @format */

import React from "react";

//material ui
import { Box } from "@mui/material";

//components
import HeroSection from "../components/IntroductoryCourse/HeroSection";
import Motivation from "../components/IntroductoryCourse/Motivation";
import ClassesCarrousel from "../components/IntroductoryCourse/ClassesCarrousel";
import Technologies from "../components/IntroductoryCourse/Technologies";
import Certification from "../components/IntroductoryCourse/Certification";
import Modalities from "../components/IntroductoryCourse/Modalities";
import Booking from "../components/IntroductoryCourse/Booking";
import YourPace from "../components/IntroductoryCourse/YourPace";
import Community from "../components/IntroductoryCourse/Community";
import { useCourses } from "../context/CourseContext";

const useStyles = () => ({
  container: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
  },
});

const IntroductoryCourse = () => {
  const classes = useStyles();

  const { atrCourse, introCourses } = useCourses();

  return (
    <>
      <Box sx={classes.container}>
        <HeroSection />
        <Motivation />
        <ClassesCarrousel />
        <Technologies />
        <Certification />
        <Modalities atrCourse={atrCourse} introCourses={introCourses} />
        <Booking  />
        <YourPace />
        <Community />
      </Box>
    </>
  );
};

export default IntroductoryCourse;
